import { UnitData } from './UnitData';
export class UnitConverter{
	unitMap:Map<string,UnitData>;
	//['degC','bar','kW','kWh','kWhd','perc','lpm','h'];
	constructor(){
		this.unitMap = new Map<string,UnitData>();
		let data = [
			{
				"id":"STD_UNIT_CELSIUS_NORMAL_LEFT",
				"className":"degC",
				"symbol":"°C"
			},
			{
				"id":"STD_UNIT_BAR_NORMAL_LEFT",
				"className":"bar",
				"symbol":"bar"
			},
			{
				"id":"STD_UNIT_HOUR_NORMAL_LEFT",
				"className":"hours",
				"symbol":"h"
			},
			{
				"id":"AICI_UNIT_HOUR",
				"className":"hours",
				"symbol":"h"
			},
			{
				"id":"STD_UNIT_KELVIN_NORMAL_LEFT",
				"className":"kelvin",
				"symbol":"K"
			},
			{
				"id":"STD_UNIT_LITER_PRO_MINUTE_NORMAL_LEFT",
				"className":"lpm",
				"symbol":"l/min"
			},
			{
				"id":"STD_UNIT_PERCENT_NORMAL_LEFT",
				"className":"percent",
				"symbol":"%"
			},
			{
				"id":"AICI_UNIT_PERCENT",
				"className":"percent",
				"symbol":"%"
			},
			{
				"id":"STD_UNIT_MINUTES_NORMAL_LEFT",
				"className":"min",
				"symbol":"min"
			},
			{
				"id":"STD_UNIT_PERCENT_RELATIVE_NORMAL_LEFT",
				"className":"percent_rel",
				"symbol":"%rel"
			},
			{
				"id":"STD_UNIT_PPM_NORMAL_LEFT",
				"className":"ppm",
				"symbol":"ppm"
			},
			{
				"id":"AICI_UNIT_ROTATIONSPERMINUTE",
				"className":"rpm",
				"symbol":"rpm"
			},
			{
				"id":"AICI_UNIT_WH",
				"className":"Wh",
				"symbol":"Wh"
			},
			{
				"id":"AICI_UNIT_SECOND",
				"className":"seconds",
				"symbol":"s"
			},
			{
				"id":"AICI_UNIT_KWH",
				"className":"kWh",
				"symbol":"kWh"
			},
			{
				"id":"AICI_UNIT_KWHD",
				"className":"kWh",
				"symbol":"kWh/d"
			},
			{
				"id":"AICI_UNIT_KW",
				"className":"kW",
				"symbol":"kW"
			},
			{
				"id":"AICI_UNIT_SECOND",
				"className":"seconds",
				"symbol":"s"
			}
		];
		for(let d of data){
			this.unitMap.set(d.id,new UnitData(d.id,d.className,d.symbol));
			if(d.id != d.id.toLowerCase()){
				this.unitMap.set(d.id.toLowerCase(),new UnitData(d.id,d.className,d.symbol));
			}
		}
	}
	getClassName(id:string):string{
		if([undefined,null,""].includes(id)){
			return '';
		}
		if(this.unitMap.has(id)){
			return this.unitMap.get(id).getClassName();
		}
		console.log("Type of id: "+(typeof id) + " content: "+id);
		if(this.unitMap.has( id.toLowerCase() )){
			return this.unitMap.get( id.toLowerCase() ).getClassName();
		}

		return '';
	}
	getSymbol(id:string):string{
		if(this.unitMap.has(id)){
			return this.unitMap.get(id).getSymbol();
		}
		return '';
	}
}